import { render } from "./ChevronRight.vue?vue&type=template&id=fb75e924"
const script = {}

import exportComponent from "/home/waiheke/waiheke.co.nz/releases/20240610012051/themes/waiheke/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__